/*
*国籍
*/
const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/hotel/common/getCountryList',
        data: data
    }
    return __request(pParameter)
}
export default request